module.exports = __webpack_public_path__ + "static/img/xiqu.c919aacb.png";